import React, { useState } from "react";
import { Box } from "@mui/material";
import ContactSearch from "../utils/ContactSearch"; // Caminho depende da sua estrutura
import ChatWindow from "../components/ChatWindow";

const ChatPage = () => {
  const [selectedContact, setSelectedContact] = useState(null);

  return (
    <Box sx={{ display: "flex", flexDirection: "row", height: "100vh" }}>
      {/* Lado esquerdo: busca e lista de contatos */}
      <Box sx={{ width: "30%", borderRight: "1px solid #ccc", p: 2 }}>
        <ContactSearch onSelectContact={setSelectedContact} />
      </Box>

      {/* Lado direito: janela do chat */}
      <Box sx={{ flex: 1 }}>
        <ChatWindow selectedContact={selectedContact} />
      </Box>
    </Box>
  );
};

export default ChatPage;
